var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 88,
    viewBox: "0 0 86 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_243_459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.9432 27.5189C62.6937 27.4835 62.4443 27.4835 62.1948 27.5189C56.6711 27.3418 52.2878 22.8439 52.2878 17.3189C52.2878 11.6877 56.885 7.0835 62.5868 7.0835C68.2531 7.0835 72.8858 11.6522 72.8858 17.3189C72.8502 22.8439 68.4669 27.3418 62.9432 27.5189Z",
    fill: "#FAB27B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5607 52.0625C70.5694 54.7187 64.9744 55.7104 59.8071 55.0375C61.1613 52.1333 61.874 48.9104 61.9096 45.5104C61.9096 41.9687 61.1256 38.6041 59.6289 35.6645C64.9031 34.9562 70.4981 35.9479 74.525 38.6041C80.1556 42.2875 80.1556 48.3437 74.5607 52.0625Z",
    fill: "#FAB27B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4221 27.5189C23.6716 27.4835 23.921 27.4835 24.1705 27.5189C29.6942 27.3418 34.0775 22.8439 34.0775 17.3189C34.0775 11.6522 29.4804 7.0835 23.7785 7.0835C18.1123 7.0835 13.5151 11.6522 13.5151 17.3189C13.5151 22.8439 17.8984 27.3418 23.4221 27.5189Z",
    fill: "#FAB27B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8143 45.5106C23.8143 48.946 24.5626 52.2043 25.9168 55.1439C20.8921 55.6751 15.6535 54.6126 11.8047 52.0981C6.17414 48.3793 6.17414 42.3231 11.8047 38.6043C15.6179 36.0543 20.999 35.0272 26.0594 35.5939C24.5983 38.5689 23.8143 41.9335 23.8143 45.5106Z",
    fill: "#FAB27B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6637 56.2062C43.3786 56.1708 43.0579 56.1708 42.7371 56.2062C36.18 55.9937 30.9414 50.6458 30.9414 44.0583C30.977 37.3292 36.4294 31.875 43.236 31.875C50.007 31.875 55.4951 37.3292 55.4951 44.0583C55.4594 50.6458 50.2565 55.9937 43.6637 56.2062Z",
    fill: "#FAB27B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.082 63.5376C26.7009 67.1147 26.7009 72.9938 32.082 76.5355C38.2115 80.6084 48.261 80.6084 54.3905 76.5355C59.7717 72.9584 59.7717 67.0793 54.3905 63.5376C48.2967 59.4647 38.2471 59.4647 32.082 63.5376Z",
    fill: "#FAB27B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_243_459",
    x: 3.58179,
    y: 7.0835,
    width: 79.1707,
    height: 80.5068,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_243_459"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_243_459",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.c8fb1533ca7cecbbeb2379670dfd2b8b.svg";
export { ForwardRef as ReactComponent };